import {
    createTheme
} from '@mui/material/styles';
export const LAYOUT = {
    pagePad: { xs: "16px", md: "40px" },
    gridPadY: { xs: "16px", md: "32px" },
    gridPadBottom: { xs: "16px", md: "56px" },
    productCols: { xs: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" },
    collCols: { xs: "1fr", lg: "repeat(3, 1fr)" },
    railCardW: { xs: "160px", md: "232px" },
    bannerH: { xs: "110px", md: "150px" },
    tabW: { xs: "50%", md: "170px" },
    avatar: 104,
    avatarRing: "0 2px 12px rgba(0,0,0,0.12)",
    gridGap: "24px"
};

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 540,
            md: 720,
            lg: 960,
            xl: 1140
        },
    },
    palette: {
        background: {
            default: '#FFFFFF',
        }
    },
    components: {
        MuiContainer: {
            defaultProps: {
                maxWidth: "xl"
            }
        },
        MuiTypography: {
            styleOverrides: {
                body1: {
                    lineHeight: "20px",
                    fontSize: "14px"
                }
            }
        }
    },
    typography:{
        allVariants:{
            color: "#2b2b2b",
            fontFamily: ['"Visuelt Pro"',"Helvetica", "Arial", "Roboto","sans-serif"].join(',')
        },
        fontFamily: ['"Visuelt Pro"',"Helvetica", "Arial", "Roboto","sans-serif"].join(',')
    }
});

theme.typography.h1 = {
    ...theme.typography.h1,
    lineHeight: "49px",
    fontSize: "40px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '40px',
        lineHeight: "49px"
    }
}

theme.typography.h2 = {
    ...theme.typography.h2,
    lineHeight: "37px",
    fontSize: "30px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '45px',
        lineHeight: "55px"
    }
}

theme.typography.h3 = {
    ...theme.typography.h3,
    lineHeight: "31px",
    fontSize: "24px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '35px',
        lineHeight: "42px"
    }
}
theme.typography.h4 = {
    ...theme.typography.h4,
    lineHeight: "26px",
    fontSize: "20px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '25px',
        lineHeight: "30px"
    }
}
theme.typography.subtitle2={
    ...theme.typography.subtitle2,
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '18px',
        lineHeight: "22px"
    }
}


theme.tvp = {
    surface: "#F5F6F8",
    card: "#FFFFFF",
    hairline: "#CCCCCC",
    textSubtle: "#666666",
    textBody: "#212121",
    textPrimary: "#000000",
    accent: "#C8102E",
    cta: "#0B1F3F",
    ctaHover: "#1C3A6B",
    ctaInk: "#FFFFFF",
    radiusCard: "10px",
    radiusMedia: "10px",
    radiusThumb: "4.11px",
    radiusPanel: "8px",
    radiusCtl: "999px",
    shadowRest: "0 0 0 1px rgba(0,0,0,0.06)",
    shadowHover: "0 12px 32px rgba(0,0,0,0.14)",
    cardHover: "0 8px 24px rgba(0,0,0,0.10)",
    tileHover: "0 12px 30px rgba(0,0,0,0.12)",
    layout: LAYOUT
}

export default theme;